module.exports = __webpack_public_path__ + "img/nplex_map.92cfa405.png";